import { render, staticRenderFns } from "./OrderdetailArsip.vue?vue&type=template&id=659f5d6b"
import script from "./OrderdetailArsip.vue?vue&type=script&lang=js"
export * from "./OrderdetailArsip.vue?vue&type=script&lang=js"
import style0 from "./OrderdetailArsip.vue?vue&type=style&index=0&id=659f5d6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports